import { Pipe, PipeTransform } from '@angular/core';
import { AreaTypeEnum } from '@commons/enums/area-type.enum';

@Pipe({
  name: 'areaTypeImg'
})
export class AreaTypeImgPipe implements PipeTransform {

  transform(type: AreaTypeEnum): string {
    if (type === AreaTypeEnum.Circle) {
      return '/assets/img/areas/active@3x.png';
    }
    if (type === AreaTypeEnum.Line) {
      return '/assets/img/areas/active_3@2x.png';
    }
    return '/assets/img/areas/active_4@2x.png';
  }

}
